import { ConstraintValidator, ConstraintValue } from '../index';
import useConstraintValidatorHelper from './constaintValidatorHelper';

export interface UrlConstraintValidator extends ConstraintValidator<string> {
}

export default function useUrlConstraintValidator(): UrlConstraintValidator {

  const helperFactory = useConstraintValidatorHelper<string>();

  const validate = (
    object: Record<string, any>,
    fieldName: string,
    constraintConfiguration: ConstraintValue<string>,
  ): boolean => {

    // URL regex pattern that validates common URL formats including query parameters
    const re = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?(\?[;&a-z\d%_.,~+=-]*)?(#[-a-z\d_]*)?$/i;

    const helper = helperFactory.createHelper(
      object,
      fieldName,
      constraintConfiguration,
    );
    const value = helper.getValue();

    if (helper.hasValue()) {
      return !!value.match(re);
    } else {
      return true;
    }
  };

  const getErrorMessage = (config: ConstraintValue<string>) => {
    return (typeof config === 'object' && config.message)
      || 'The field value should be a valid URL';
  };

  return {
    getName: () => 'url',
    validate,
    getErrorMessage,
  };
}
